export const cardData = [
    {
        title: "Digital Transformation",
        content: "Our Digital Transformation solutions can help companies identify the gaps in their strategy and invest in the best open technologies, offering key insights to drive digital strategy. Our strategy is drawn on a critical optimizing legacy systems to scale fast with the new-age digital offerings."
    }, {
        title: "Software Development",
        content: "We carry a rich experience of over a decade in customer software development. We ensure that your software is implemented efficiently and with no hidden costs. Our best-in-class tech stack enables a multitude of new features for your software."
    }, {
        title: "QA & Testing",
        content: "We offer comprehensive testing and QA services, including manual testing, automated, performance, and security testing utilizing modern test frameworks and technologies. If you need a quality assurance service for your existing solutions, you can rely on our experience, and expertise."
    }, {
        title: "Dedicated Team",
        content: "Upscale your development capabilities by extending your existing team. Our dedicated software development teams have expertise across a variety of technologies and build applications that offer ease of scalability, reduced time-to-market."
    }
]
export const offShoreImg = [
    "offShoreImg"
]
export const offShoreTitle = [
    "Reliable Offshore Development Services"
]
export const offShorePara = [
    "IStellar is an Agile offshore development service company with synergies environment to boost IT needs of your businesses with result oriented people. We use globally accepted industry proven processes to turn clients vision into reality. You can avail the most out of our full-fledged ODC model. These models are fabricated in such a way that it stays highly transparent and are flexible to the core. Our ODC models have gained huge customer traction and much appreciation from a potential set of customers as they have figured it out to be one of the highly flexible engagement models that are available in the market. By availing our offshore development services, you are given an opportunity to revamp your business landscapes to an enhanced one over the conventional methods and practices.",
    "Call us today! Reshape, Reinvent and Stand out as the leader in the digital business world!"
]
export const digitalPara = [
    "IStellar Digital business transformation services help achieve tangible outcomes for your business and establish business agility through optimized solutions."
]
export const digitalBusinessTitle = [
    "Leading Digital Business For Software Solution"
]
export const digitalBusinessPara = [
    "At Mitrahsoft, we help businesses with their digital transformation. Our experts continually ideate and prototype new concepts in our dedicated Center of Excellence with an aim to architect new models of disruption. We also help you build and deploy customized solutions that help you ride over business challenges and gain a competitive edge. We can do it for you too",
    "Our team of experts design and create solutions for digital transformations required by an organization, which is unique to every client. We believe that by combining our expertise in Microservices, Web, Cloud and Mobility we can come up with solutions that enhance the productivity for our clients.",
    "Let your digital transformation initiative be guided by industry's leading consulting services company. Formulate your digital transformation strategy with industry's leading digital transformation consultants."
]
export const digitalCardData = [
    {
        id: 1,
        title: "Enterprise Mobility",
        content: "We combine the latest in mobile technology to deliver mobile-first enterprise solutions that improve revenue channels and staff efficiency and increase customer loyalty."
    }, {
        id: 2,
        title: "Agile Transformation",
        content: "We enable organizations to innovate and deliver more effectively than ever—turning market disruption to competitive advantage as a part of our digital transformation solutions."
    }, {
        id: 3,
        title: "Application Modernization",
        content: "Transforming legacy applications to drive agility and efficiency through modern IT stands at the core of Application Modernization Services. Ideally, these services cut down unnecessary costs and maintenance burden that legacy or outdated applications might be causing to your organization."
    }, {
        id: 4,
        title: "Cloud",
        content: "Our cloud services will enable your enterprise to connect with all your business needs while also expand globally to deliver differentiated services to your end users from anywhere."
    }
]
export const hiringPara = [
    "IStellar provide the flexibility of choosing the best suited engagement model to all our clients."
]
export const hiringTable = [
    {
    "col1" : "",
    "col2" : "Full-Time",
    "col3" : "Part-Time",
    "col4" : "Hourly",
    }, {
    "col1" : "Working Hours",
    "col2" : "160 hours/month",
    "col3" : "80 hours/month",
    "col4" : "Flexible",
    }, {
    "col1" : "Communication Channel",
    "col2" : "Phone, Skype, Slack",
    "col3" : "Phone, Skype, Slack",
    "col4" : "Phone, Skype, Slack",
    }, {
    "col1" : "Hiring Period",
    "col2" : "3 Months (min)",
    "col3" : "1 Months (min)",
    "col4" : "25 Hours (min",
    }, {
    "col1" : "Billing",
    "col2" : "Monthly",
    "col3" : "Monthly",
    "col4" : "Weekly",
    }, {
    "col1" : "Reporting",
    "col2" : "Daily",
    "col3" : "Task Wise",
    "col4" : "Flexible",
    }, 
]
export const Contact = [
"Start working with IStellar that can provide everything you need to generate awareness, drive traffic, connect.",
]